import { useCallback } from "react";
import type {
  CrearClienteModalProps,
  UseCrearClienteModalReturn,
} from "./types";

export const useCrearClienteModal = ({
  setIsModalCreateClienteExistente,
  setisModalCreateCliente,
  setisModalCreateClienteNew,
}: CrearClienteModalProps): UseCrearClienteModalReturn => {
  const handleClose = useCallback(() => {
    setisModalCreateCliente(false);
  }, [setisModalCreateCliente]);

  const handleNuevoCliente = useCallback(() => {
    setisModalCreateClienteNew(true);
    setisModalCreateCliente(false);
  }, [setisModalCreateCliente, setisModalCreateClienteNew]);

  const handleClienteExistente = useCallback(() => {
    setIsModalCreateClienteExistente(true);
    setisModalCreateCliente(false);
  }, [setIsModalCreateClienteExistente, setisModalCreateCliente]);

  return {
    handleClienteExistente,
    handleClose,
    handleNuevoCliente,
  };
};
